import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPersons, fetchPersons } from '../../store/features/personSlice';
import AtomicSpinner from 'atomic-spinner';
import { Button } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import PersonView from './personView';
import styles from './person.module.scss';
import Pagination from '../../models/Pagination';
import TableControl from '../../component/_shared/table/tableControl';
import WithNotify from '../../component/_HighOrder/withNotify';

const Provider = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [openFilter, setOpenFilter] = useState(false);
    const [person, setPerson] = useState(null);
    const token = useSelector((state) => state.user.token);
    const [pagination, setPagination] = useState({ ...(new Pagination(1, 10, '', 'ASC')) });
    const [filter, setFilter] = useState({
        gender: '',
        birthDate: '',
        managingOrganization: '',
        active: true
    });
    const persons = useSelector((state) => state.person.persons);

    useEffect(() => {
        getPersons();
    }, []);

    const getPersons = () => {
        setLoading(true);
        dispatch(fetchPersons({
            filter,
            pagination,
            token,
            callback: (response) => {
                dispatch(setPersons(response.Data));
                setPagination(new Pagination().set(pagination).setCount(response.Rows))
                setLoading(false);
            },
            catch: (error) => {
                dispatch(setPersons([]));
                setLoading(false);
                props.notify.error(error.message);
            }
        }));
    };

    const clearFilter = () => {
        setFilter({
            gender: '',
            birthDate: '',
            managingOrganization: '',
            active: true
        });
    };

    const getFilter = () => {
        if (!openFilter)
            return <></>;

        return (
            <div className={styles.filterDiv}>
                <div className={styles.filterItem}>
                    <p>Gender</p>
                    <input type='text' value={filter.gender} onChange={(event) => setFilter({ ...filter, gender: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Birthdate</p>
                    <input type='text' value={filter.birthDate} onChange={(event) => setFilter({ ...filter, birthDate: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Managing Organization</p>
                    <input type='text' value={filter.managingOrganization} onChange={(event) => setFilter({ ...filter, managingOrganization: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Active</p>
                    <select value={filter.active} onChange={(event) => setFilter({ ...filter, active: event.target.value })} style={{ fontSize: 12, height: 20 }}>
                        <option value={''}></option>;
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                    </select>
                </div>
                <div className={styles.filterItem}>
                    <Button onClick={getPersons}>
                        Search
                    </Button>
                    <Button onClick={clearFilter}>
                        Clear
                    </Button>
                </div>
            </div>
        )
    };

    const viewDetails = (id) => {
        setPerson(persons.entry.filter((item) => item.resource.id.value === id)[0]);
    };

    const mountRows = () => {
        return persons.entry.map((item, index) => {
            if (item.resource.meta?.source?.value)
                return <tr key={index} className={(index % 2) > 0 ? styles.oddLine : styles.evenLine}>
                    <td className={styles.tableColumn}>
                        <p>{item.resource.id.value}</p>
                    </td>
                    <td className={styles.tableColumn} colSpan='4'>
                        <p>{item.resource.meta.source.value}</p>
                    </td>    
                </tr>

            return <tr key={index} className={(index % 2) > 0 ? styles.oddLine : styles.evenLine}>
                <td className={styles.tableColumn}>
                    <p>{item.resource.id.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.managingOrganization?.reference?.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.gender.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.birthDate ? new Date(item.resource.birthDate?.value).toLocaleDateString('en-us', {year: "numeric", month: "short", day: "numeric" }) : ''}</p>
                </td>
                <td className={styles.tableColumn}>
                    <Button onClick={() => viewDetails(item.resource.id.value)}>
                        <MenuOpenIcon />
                    </Button>
                </td>
            </tr>
        });
    };

    const getList = () => {
        if (person)
            return <></>;

        return (
            loading ? <div className={styles.atomicSpiner}><AtomicSpinner /></div>
                :
                <Fragment>
                    <Button color='primary' onClick={() => setOpenFilter(!openFilter)}>
                        <FilterListIcon />
                        Filter
                    </Button>
                    {getFilter()}
                    <br />
                    <br />
                    <table className={styles.practitionerTable}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Managing Organization</th>
                                <th>Gender</th>
                                <th>Birth Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                persons && persons.entry?.length > 0 ?
                                    mountRows()
                                    :
                                    <tr>
                                        <td colSpan='3'>
                                            <p>No Results</p>
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                    {persons && persons.entry?.length > 0 ? <TableControl pagination={pagination} setPagination={setPagination} /> : <></>}
                </Fragment>
        );
    };

    const getView = () => {
        if (person)
            return (
                <div>
                    <button className={styles.filterBtn} onClick={getBack}>Back</button>
                    <PersonView person={person}></PersonView>
                </div>
            );

        return <></>;
    };

    const getBack = () => {
        setPerson(null);
    };

    return (
        <div className={styles.practitionerDiv}>
            <h2>Person Page</h2>

            {getView()}

            {getList()}
        </div>
    );
};

export default WithNotify(Provider);